var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLightUsers(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 54,
    viewBox: "0 0 53 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.2188 33.625C24.1644 33.625 28.9844 28.8051 28.9844 22.8594C28.9844 16.9137 24.1644 12.0938 18.2188 12.0938C12.2731 12.0938 7.45312 16.9137 7.45312 22.8594C7.45312 28.8051 12.2731 33.625 18.2188 33.625Z",
    stroke: "#2C3B60",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.1726 12.4871C33.1243 12.229 34.1057 12.0968 35.0917 12.0938C37.947 12.0938 40.6852 13.228 42.7042 15.2469C44.7231 17.2659 45.8574 20.0042 45.8574 22.8594C45.8574 25.7146 44.7231 28.4529 42.7042 30.4718C40.6852 32.4908 37.947 33.625 35.0917 33.625",
    stroke: "#2C3B60",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.3125 41.368C4.99348 38.9759 7.22547 37.0235 9.81992 35.6757C12.4144 34.3279 15.2951 33.6243 18.2188 33.6243C21.1424 33.6243 24.0231 34.3279 26.6176 35.6757C29.212 37.0235 31.444 38.9759 33.125 41.368",
    stroke: "#2C3B60",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M35.0918 33.625C38.0157 33.6232 40.897 34.3259 43.4917 35.6738C46.0865 37.0216 48.3182 38.9748 49.998 41.368",
    stroke: "#2C3B60",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightUsers);
export default __webpack_public_path__ + "static/media/LightUsers.b7693ec44cd4a84adcece142615360ba.svg";
export { ForwardRef as ReactComponent };